<template>
	<div>
		<div class="subtitle">
			{{ isAddMode ? $t('selection_list_header.add_title', { title }) : $t('selection_list_header.selected_title', { title }) }}
		</div>

		<div class="field" v-if="!useDropdownInsteadOfSearch">
			<label class="label">{{ $t('selection_list_header.search_label') }}</label>
			<div class="control">
				<input
					type="text"
					class="input"
					:placeholder="$t('selection_list_header.search_placeholder', { title })"
					v-model="searchValue"
					@input="search"
					@keyup.esc="clearSearch"
				/>
			</div>
		</div>
		<div class="field" v-else>
			<label class="label">{{dropdownTitle}}</label>
			<div class="control">
				<v-select
					class="panel-select header"
					v-model="dropdownSelection"
					:options="dropdownOptions"
					:placeholder="dropdownPlaceholder"
					:allowEmpty="false"
					:internalSearch="false"
					:showLabels="false"
					@search-change="searchDropdown"
					@select="changeDropdownSelection"
					track-by="id"
					label="name"
				>
					<span slot="noResult">{{ $t('selection_list_header.no_results') }}</span>
					<span
						slot="caret"
						slot-scope="{ toggle }"
						class="caret"
						@mousedown.prevent.stop="toggle()"
					><i class="fas fa-caret-down caret-inner" /></span>
				</v-select>
			</div>
		</div>
	</div>
</template>


<script>
export default {
	props: {
		title: String,
		tab: Number,
		mode: String,
		useDropdownInsteadOfSearch: Boolean,
		dropdownTitle: String,
		dropdownOptions: Array,
		dropdownPlaceholder: String,
		searchValueProp:  String
	},
	data() {
		return {
			searchValue: '',
			dropdownSelection: {}
		};
	},
	watch: {
		tab: {
			handler: function() {
				this.clearSearch();
			}
		}
	},
	computed: {
		isAddMode() {
			return this.mode == 'add' ? true : false;
		}
	},
	methods: {
		search() {
			this.$emit('search', this.searchValue);
		},
		clearSearch() {
			this.searchValue = '';
			this.search();
		},
		changeDropdownSelection(item) {
			this.$emit('changeDropdownSelection', item);
		},
		searchDropdown(value) {
			this.$emit('searchDropdown', value);
		}
	},
	created() {
		if (this.useDropdownInsteadOfSearch && this.dropdownOptions) {
			this.dropdownSelection = this.dropdownOptions[0];
		}
		
		this.searchValue = this.searchValueProp;
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.subtitle {
  min-width: 130px;
  padding-top: 10px;
  margin-bottom: 0.5rem !important;
  font-weight: 600;
}

.label {
  font-size: 12px;
}

.field {
  border-bottom: 1px solid $lightest-grey;
  padding-bottom: 15px;
  margin-bottom: 15px;
  margin: 10px;
  .input {
    background: white;
    max-width: 300px;
  }
}
</style>
